const handleAccordion = () => {
	const $accordion = $('.js-accordion');

	$accordion.on('show.bs.collapse', function (event) {
		$(event.target).closest('.card').addClass('is-active');
	})

	$accordion.on('hide.bs.collapse', function (event) {
		$(event.target).closest('.card').removeClass('is-active');
	})
};

handleAccordion();
